import script from "./TechnicalIndicators.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicalIndicators.vue?vue&type=script&setup=true&lang=js"

import "./TechnicalIndicators.vue?vue&type=style&index=0&id=858a48ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-858a48ce"]])

export default __exports__